var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"commentBar",style:({position: _vm.fixed ? 'fixed' : 'relative', top: _vm.fixed ? _vm.celling + 'px' : ''})},[_c('span',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.quantity))+"条")]),_c('img',{attrs:{"src":require("../../assets/images/comment_btn.png"),"alt":"comment"},on:{"click":_vm.handleComment}})])
}
var staticRenderFns = []

export { render, staticRenderFns }